module.exports = __webpack_public_path__ + "img/04.b2d313fc.jpg";